import type {
  AiChatApiEnvelope,
  AiChatPayload,
  AiChatRequestBody,
} from "@/feature/ai-planner/types/ai-chat.types";
import { baseApi } from "@/redux/api/base-api";

const AI_CHAT_ENDPOINT = "/b2c/ai/chat";

const aiChatApi = baseApi.injectEndpoints({
  overrideExisting: true,
  endpoints: (builder) => ({
    sendAiPlannerMessage: builder.mutation<AiChatPayload, AiChatRequestBody>({
      query: (body) => ({
        url: AI_CHAT_ENDPOINT,
        method: "POST",
        body,
      }),
      transformResponse: (response: AiChatApiEnvelope) => {
        if (!response.data) {
          throw new Error("AI response format is invalid.");
        }
        return response.data;
      },
      transformErrorResponse: (response) => {
        const envelope = response.data as AiChatApiEnvelope | undefined;
        const message =
          envelope?.data?.message ??
          envelope?.message ??
          (typeof response.status === "number" && response.status >= 500
            ? "AI Planner is temporarily unavailable."
            : "Could not send your message. Please try again.");
        return message;
      },
    }),
  }),
});

export const { useSendAiPlannerMessageMutation } = aiChatApi;
